import { useMotionValueEvent, useScroll, useVelocity } from 'framer-motion'
import { FC, Fragment, useCallback } from 'react'
import { debounce } from 'underscore'
import { useShallow } from 'zustand/react/shallow'
import { useScrollContext } from './scrollContext'
import { scrollRef } from './scrollSignals'
export const ScrollWrapper: FC<{ children: any }> = ({ children }) => {
    const { scrollY, scrollYProgress } = useScroll({
        container: scrollRef.value,
    })
    const { atTop, atBottom, headerHeight, toggleHeader } = useScrollContext(
        useShallow((s) => ({
            atTop: s.atTop,
            atBottom: s.atBottom,
            headerHeight: s.headerHeight,
            toggleHeader: s.toggleHeader,
        }))
    )
    const velocity = useVelocity(scrollY)
    const DEBOUNCE_TIME = 10

    const handleScrollYChange = useCallback(() => {
        return debounce((latest: number) => {
            const SCROLL_THRESHOLD = headerHeight
            const latTop = latest <= SCROLL_THRESHOLD
            if (atTop !== latTop) {
                useScrollContext.getState().setAtTop(latTop)
            }
        }, DEBOUNCE_TIME)
    }, [atTop])

    const handleProgressYChange = useCallback(() => {
        return debounce((latest: number) => {
            if (latest > 0.8 && !atBottom) {
                useScrollContext.getState().setAtBottom(true)
            } else if (latest < 0.8 && atBottom) {
                useScrollContext.getState().setAtBottom(false)
            }
        }, DEBOUNCE_TIME)
    }, [atBottom])

    useMotionValueEvent(scrollYProgress, 'change', (latest) => {
        handleProgressYChange()(latest)
    })

    useMotionValueEvent(scrollY, 'change', (latest) => {
        handleScrollYChange()(latest)
    })

    useMotionValueEvent(velocity, 'change', (newValue) => {
        if (newValue !== 0 && headerHeight === 156) {
            toggleHeader()
        }
    })

    /// reRender elem stored for rerender issue on android. forces rerender of this elem.
    return (
        <Fragment>
            {children}
            <div
                id="reRender"
                style={{
                    position: 'absolute',
                    visibility: 'hidden',
                    opacity: 0,
                    height: '1px',
                    width: '1px',
                    backgroundColor: 'black',
                    top: '0',
                    right: '0',
                    zIndex: 99999999,
                }}
            />
        </Fragment>
    )
}
